import {Gift, PersonWhoBookedGift} from 'types/index';

import * as modalNames from 'constants/modals';
import * as appActions from 'app/actions';
import {bookGiftByGuest, fetchActiveGiftsForGuest, fetchRealizedGiftsForGuest} from 'services/api';

import * as types from '../actionTypes';
import {SearchParams} from '../types';

type ShowBookGiftConfirmModalParams = {
    gift: Gift;
    personWhoBooked: PersonWhoBookedGift;
    onConfirm(): void;
};

type Pagination = {page: number; size: number};

type FetchGiftsParams = {
    searchParams: SearchParams;
    pagination: Pagination;
};

const showBookGiftConfirmModal = ({gift, personWhoBooked, onConfirm}: ShowBookGiftConfirmModalParams) => {
    return function(dispatch: any) {
        const params = {
            name: modalNames.GIFT_BOOKING_CONFIRM_MODAL,
            data: {
                gift,
                personWhoBooked,
            },
            onSubmit: onConfirm,
        };
        dispatch(appActions.showModal(params));
    };
};

const showBookGiftSuccessModal = (gift: Gift) => {
    return function(dispatch: any) {
        const params = {
            name: modalNames.BOOKING_SUCCESS_MODAL,
            data: {
                gift,
            },
        };
        dispatch(appActions.showModal(params));
    };
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getEmptyGiftsListAction = (pagination: Pagination) => {
    return {
        type: types.LIST_GIFTS_RECEIVED,
        payload: {
            gifts: [],
            pagination: {page: pagination.page, size: pagination.size, pagesCount: 0},
        },
    };
};

export function fetchGifts({searchParams, pagination}: FetchGiftsParams): any {
    return function(dispatch: any) {
        dispatch(appActions.showLoaderSpinner());

        fetchActiveGiftsForGuest({
            page: pagination.page,
            size: pagination.size,
            status: searchParams.status,
        })
            .then(response => {
                dispatch({
                    type: types.LIST_GIFTS_RECEIVED,
                    payload: {
                        gifts: response.data.items,
                        pagination: {
                            page: pagination.page,
                            size: pagination.size,
                            pagesCount: response.data.pages,
                            itemsCount: response.data.itemsCount,
                        },
                    },
                });
            })
            .catch(error => {
                console.warn('Error on fetch active gifts for guest role: ', error);
                dispatch(getEmptyGiftsListAction(pagination));
            })
            .finally(() => dispatch(appActions.hideLoaderSpinner()));
    };
}

export function fetchRealizedGifts({searchParams, pagination}: FetchGiftsParams): any {
    return function(dispatch: any) {
        dispatch(appActions.showLoaderSpinner());

        fetchRealizedGiftsForGuest({
            page: pagination.page,
            size: pagination.size,
            status: searchParams.status,
        })
            .then(response => {
                dispatch({
                    type: types.LIST_GIFTS_RECEIVED,
                    payload: {
                        gifts: response.data.items,
                        pagination: {
                            page: pagination.page,
                            size: pagination.size,
                            itemsCount: response.data.itemsCount,
                            pagesCount: response.data.pages,
                        },
                    },
                });
            })
            .catch(error => {
                console.warn('Error on fetch realized gifts: ', error);
                dispatch(getEmptyGiftsListAction(pagination));
            })
            .finally(() => dispatch(appActions.hideLoaderSpinner()));
    };
}

export function bookGift(gift: Gift, personWhoBooked: PersonWhoBookedGift): any {
    return function(dispatch: any) {
        const continueBookGift = (): void => {
            dispatch(appActions.showLoaderSpinner());

            bookGiftByGuest(gift, personWhoBooked)
                .then(response => {
                    dispatch({
                        type: types.SELECTED_GIFT_BOOKED,
                        payload: response.data,
                    });
                    dispatch(showBookGiftSuccessModal(response.data));
                })
                .catch(error => {
                    console.warn('Error on fetch gifts for guest role: ', error);
                })
                .finally(() => dispatch(appActions.hideLoaderSpinner()));
        };

        const confirmParams = {
            onConfirm: continueBookGift,
            gift,
            personWhoBooked,
        };

        dispatch(showBookGiftConfirmModal(confirmParams));
    };
}
